module.exports = __webpack_public_path__ + "media/bg2.d734b46f.mp3";